app.component('homeCard', {
    templateUrl: 'app/common/component/homeCard/homeCard.html',
    transclude: {
        avatar : "?homeCardAvatar",
        headertext : "?homeCardHeaderText",
        content : "?homeCardContent",
        actions : "?homeCardActions"
    }
});
